import type { PropsWithChildren } from "react";

type DrawerContentProps = PropsWithChildren;

export function DrawerContent({ children }: DrawerContentProps) {
  return (
    <div className="flex grow-1 flex-col p-main pt-2 first:pt-main last:pb-0">
      {children}
    </div>
  );
}
